/**
 * Magasin du recu, lu sur le poste (aucun reseau) : la configuration de
 * GET /caisse/config gardee dans `meta` (META_KEYS.CAISSE_CONFIG, la plus
 * recente) par-dessus celle recue a l'activation (META_KEYS.TERMINAL).
 * Raison sociale, adresse, telephone, numeros TPS et TVQ, en-tete et pied :
 * une valeur absente reste absente, le recu affiche alors « [à fournir] ».
 */
import { getMetaMany } from '../store/meta';
import { META_KEYS } from '../store/schema';

/** @returns {Promise<{ store: object, config: object, terminal: object|null }>} */
export async function chargerContexteRecu(db) {
    const values = await getMetaMany(db, [META_KEYS.TERMINAL, META_KEYS.CAISSE_CONFIG]);
    return fusionnerContexte(values[META_KEYS.TERMINAL] || null, values[META_KEYS.CAISSE_CONFIG] || null);
}

/** Configuration recente par-dessus celle de l'activation. */
export function fusionnerContexte(terminal, caisseConfig) {
    const t = terminal || {};
    const c = caisseConfig || {};
    return {
        store: { ...(t.store || {}), ...(c.store || {}) },
        config: { ...(t.config || {}), ...(c.config || {}) },
        terminal: terminal ? { terminal_id: t.terminal_id, name: t.name, store_id: t.store_id } : null,
    };
}
